import { useEffect, useState } from 'react'
import React from 'react'
import Pic1 from "../assets/Images/Customers/1.png"
import Pic2 from "../assets/Images/Customers/2.png"
import Pic3 from "../assets/Images/Customers/3.png"
import Pic4 from "../assets/Images/Customers/4.png"
import Pic5 from "../assets/Images/Customers/5.svg"
import Pic6 from "../assets/Images/Customers/6.svg"
import Pic7 from "../assets/Images/Customers/7.jpg"
import Pic8 from "../assets/Images/Customers/8.png"
import Pic9 from "../assets/Images/Customers/9.webp"
import Pic10 from "../assets/Images/Customers/10.png"
import Pic11 from "../assets/Images/Customers/11.png"
import Pic12 from "../assets/Images/Customers/12.png"
// import Pic13 from "../assets/Images/Customers/13.jpg"
import Pic14 from "../assets/Images/Customers/14.png"
import Pic15 from "../assets/Images/Customers/15.png"
import Pic16 from "../assets/Images/Customers/16.png"
import Pic17 from "../assets/Images/Customers/17.png"
import Pic18 from "../assets/Images/Customers/18.png"
import Pic19 from "../assets/Images/Customers/19.png"
import Pic20 from "../assets/Images/Customers/20.png"
import Pic21 from "../assets/Images/Customers/21.svg"
// import { useEffect } from 'react';


const logos = [
    {
        id: 1,
        img: Pic1,
        alt: "img1"
    },
    {
        id: 2,
        img: Pic2,
        alt: "img2"
    },
    {
        id: 3,
        img: Pic3,
        alt: "img3"
    },
    {
        id: 4,
        img: Pic4,
        alt: "img4"
    },
    // {
    //     id: 5,
    //     img: Pic5,
    //     alt: "img5"
    // },
    {
        id: 6,
        img: Pic6,
        alt: "img6"
    },
    {
        id: 7,
        img: Pic7,
        alt: "img7"
    },
    {
        id: 8,
        img: Pic8,
        alt: "img8"
    },
    {
        id: 9,
        img: Pic9,
        alt: "img9"
    },
    {
        id: 10,
        img: Pic10,
        alt: "img20"
    },
    {
        id: 11,
        img: Pic11,
        alt: "img11"
    },
    {
        id: 12,
        img: Pic12,
        alt: "img12"
    },
    // {
    //     id: 13,
    //     img: Pic13,
    //     alt: "img13"
    // },
    {
        id: 14,
        img: Pic14,
        alt: "img14"
    },
    {
        id: 15,
        img: Pic15,
        alt: "img15"
    },
    {
        id: 16,
        img: Pic16,
        alt: "img16"
    },
    {
        id: 17,
        img: Pic17,
        alt: "img17"
    },
    {
        id: 18,
        img: Pic18,
        alt: "img18"
    },
    {
        id: 19,
        img: Pic19,
        alt: "img19"
    },
    {
        id: 20,
        img: Pic20,
        alt: "img20"
    },
    // {
    //     id: 21,
    //     img: Pic21,
    //     alt: "img21"
    // },

];

function Customers() {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    useEffect(() => {
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    });
    let mx = 6;
    let wid = windowWidth;
    if (wid >= 920) { mx = 6; }
    else if (wid >= 560) { mx = 5; }
    else { mx = 4; }
    let f = false;
    let data = [];
    let elemens = [];
    for (let i = 0; i < logos.length; i++) {
        for (let j = 0; j < mx && i < logos.length; j++, i++) {
            console.log(i);
            console.log(logos[i]);
            console.log(logos[i].img);
            console.log(logos[i].alt);
            elemens.push(<img src={logos[i].img} className="" alt={logos[i].alt} />)
        }
        data.push(elemens);
        elemens = [];
    }
    return (
        <>
            {/* <div id="carouselExampleAutoplaying" className="carousel slide carousel-container" data-bs-ride="carousel">
                <div className="carousel-inner carousel-container">
                    {
                        data.map((ele, idx) => {
                            return <>
                                <div className={f ? "carousel-item" : "carousel-item active "} data-bs-interval="false">
                                    <div className='caousel-div'>
                                        {ele}
                                    </div>
                                </div>
                                {f = true}
                            </>
                        })
                    }

                </div>
            </div> */}
            <div class="logos">
                <div class="logos-slide">
                    {
                        data.map((ele, idx) => {
                            return <>
                                {ele}
                            </>
                        })
                    }
                </div>

                <div class="logos-slide">
                    {
                        data.map((ele, idx) => {
                            return <>
                                {ele}
                            </>
                        })
                    }
                </div>
            </div>
        </>
    )
}

export default Customers